import React, { useEffect, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useDispatch, useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { toast } from 'react-toastify';
import HeaderPage from '~/components/HeaderPage';
import TableT from '~/components/Table';
import { ApplicationState } from '~/store';
import {
  consentimentosRequest,
  getOrderHandleChangePageRequest,
  getOrderHandleChangeRowsPerPageRequest,
  postConsentimentosRequest,
} from '~/store/ducks/GerenciarConsentimento/actions';
import { Container, StyledButton } from './styles';

interface ThemeState {
  theme: 'light' | 'dark' | undefined;
}

const GerenciarConsentimento: React.FC = () => {
  const _reCaptchaRef = useRef<ReCAPTCHA>(null);

  const dispatch = useDispatch();

  const language = useSelector<ApplicationState, any>(
    state => state.language.data,
  );

  const consentimentoData = useSelector<ApplicationState, any>(
    state => state.consentimentos,
  );

  const theme = useSelector<ApplicationState, ThemeState>(state => state.theme);

  const [isVerified, setIsVerified] = useState(false);
  const [recaptcha, setRecaptcha] = useState('');
  const [recaptchaTheme, setRecaptchaTheme] = useState(true);

  useEffect(() => {
    setTimeout(() => setRecaptchaTheme(state => !state), 10);
    setTimeout(() => setRecaptchaTheme(state => !state), 20);

    _reCaptchaRef.current?.reset();
  }, [theme.theme]);

  const verifyCallback = (token: string | null) => {
    if (token) {
      setIsVerified(true);
      setRecaptcha(token);
    }
  };

  const expiredCallback = () => {
    setIsVerified(false);
    setRecaptcha('');
  };

  const dispatchConsentimentos = () => {
    if (!isVerified) {
      toast.error('Por favor preencha o reCAPTCHA');
      return;
    }

    dispatch(
      postConsentimentosRequest({
        recaptcha: recaptcha,
      }),
    );

    _reCaptchaRef.current?.reset();
    setIsVerified(false);
  };

  useEffect(() => {
    document.title = 'Gerenciar consentimento | Portal LGPD';
    dispatch(consentimentosRequest(0, 5));
  }, [dispatch]);

  return (
    <Container>
      <HeaderPage
        pageTitle={language?.gerenciarConsentimento?.gerenciarConsentimento}
      />

      <div className="content">
        <h2>
          {language?.gerenciarConsentimento?.escolhaAsAtividadesQueVoceAutoriza}
        </h2>

        {consentimentoData.loading ? (
          <TableT
            toggleAction
            data={consentimentoData.data}
            getOrderHandleChangePage={(value: number, rowsPerPage: number) =>
              dispatch(getOrderHandleChangePageRequest(value, rowsPerPage))
            }
            getOrderHandleChangeRowsPerPage={(
              value: number,
              rowsPerPage: string,
            ) =>
              dispatch(
                getOrderHandleChangeRowsPerPageRequest(value, rowsPerPage),
              )
            }
            className="table-lgpd"
          />
        ) : (
          <TableT className="table-lgpd" />
        )}
      </div>

      <div className="ReCAPTCHA">
        {process.env.REACT_APP_RECAPTCHA_SITE_KEY && recaptchaTheme ? (
          <ReCAPTCHA
            //@ts-ignore
            style={{ display: 'inline-block' }}
            theme={theme.theme}
            ref={_reCaptchaRef}
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            onChange={verifyCallback}
            onExpired={expiredCallback}
          />
        ) : (
          ''
        )}
      </div>

      <div className="buttons">
        <StyledButton
          className="help"
          type="button"
          onClick={() => {
            const toastrConfirmOptions = {
              onOk: () => {},
              onCancel: () => {},
              okText: 'Ok',
              disableCancel: true,
            };

            toastr.confirm(
              `Nesta tela, você poderá gerenciar as atividades de tratamento dos
              seus dados que estão em posse da Sky sempre que houver necessidade
              e possibilidade, com base na legislação.`,
              toastrConfirmOptions,
            );
          }}
        >
          {!!language?.gerenciarConsentimento?.ajuda &&
            language?.gerenciarConsentimento?.ajuda}
        </StyledButton>
        <StyledButton onClick={dispatchConsentimentos}>
          {!!language?.gerenciarConsentimento?.salvar &&
            language?.gerenciarConsentimento?.salvar}
        </StyledButton>
      </div>
    </Container>
  );
};

export default GerenciarConsentimento;
